export default "__VITE_ASSET__Bv5cmAYH__"